import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=3f956c44&scoped=true"
import script from "./PaymentOrder.vue?vue&type=script&lang=js"
export * from "./PaymentOrder.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=3f956c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f956c44",
  null
  
)

export default component.exports